import { $http } from '@/utils/https';
import { objectToQueryString } from '@/helpers/variables';
// @ts-ignore
import { saleRowsFrom, salePromoFrom, saleRaffleFrom } from '@/helpers/sale';
// @ts-ignore
import { buildBasketHash } from '@/helpers/gift';

interface State {
  isSalesLoading: boolean;
  sales: any;
  saleRows: { [key: string]: any };
  salePromo: any;
  saleRaffle: any;
  saleBasketHash: string;
}

let saleRequestSeq = 0;

const state: State = {
  isSalesLoading: false,
  sales: null,
  saleRows: {},
  salePromo: null,
  saleRaffle: null,
  saleBasketHash: ''
};

const getters = {
  isSalesLoading: (state: State) => state.isSalesLoading,
  sales: (state: State) => state.sales,
  saleRows: (state: State) => state.saleRows,
  salePromo: (state: State) => state.salePromo,
  saleRaffle: (state: State) => state.saleRaffle,
  saleBasketHash: (state: State) => state.saleBasketHash
};

const actions = {
  // eslint-disable-next-line no-unused-vars
  GET_PROMOTIONS_PRODUCTS: async ({ commit }: any, params: any) => {
    let url = `v1/sales`;
    if (params && Object.keys(params).length) {
      url = objectToQueryString(url);
    }
    try {
      const response = await $http.get(url);
      return response.data;
    } catch (e) {
      throw e;
    }
  },
  GET_PROMOTION: async ({ commit }: any, promoId: number) => {
    let url = `v1/sales/${promoId}`;
    try {
      const response = await $http.get(url);
      return response.data.data;
    } catch (e) {
      throw e;
    }
  },
  /**
   *
   * @param commit
   * @param params {{ids: [number]}}
   * @constructor
   */
  // eslint-disable-next-line no-unused-vars
  GET_PROMOTIONS_PRODUCTS_FOR_BASKET: async ({ commit }: any, params: any) => {
    let url = `v1/basket/products`;
    try {
      const response = await $http.get(url, { params });
      return response.data;
    } catch (e) {
      throw e;
    }
  },
  CHECK_SALES: async ({ commit, rootGetters }: any, payload: any) => {
    if (!payload || !Object.keys(payload).length) {
      saleRequestSeq++;
      commit('RESET_SALE_STATE');
      return null;
    }

    const requestId = ++saleRequestSeq;
    const requestBasketHash = buildBasketHash(rootGetters['basket/basket']);

    try {
      commit('CHANGE_SALES_LOADING', true);
      const response = await $http.get('v1/products/check-sale', {
        params: payload
      });

      if (requestId !== saleRequestSeq) return response.data.data;

      commit('SET_SALES', response.data);
      commit('SET_SALE_BASKET_HASH', requestBasketHash);
      commit('basket/UPDATE_BASKET_PRODUCTS_PRICES', response.data.data, { root: true });
      return response.data.data;
    } catch (e) {
      if (requestId === saleRequestSeq) commit('RESET_SALE_STATE');
      throw e;
    } finally {
      if (requestId === saleRequestSeq) commit('CHANGE_SALES_LOADING', false);
    }
  }
};

const mutations = {
  CHANGE_SALES_LOADING(state: State, status: boolean) {
    state.isSalesLoading = status;
  },
  SET_SALES(state: State, payload: any) {
    state.sales = (payload && payload.data) || null;
    state.saleRows = saleRowsFrom(payload);
    state.salePromo = salePromoFrom(payload);
    state.saleRaffle = saleRaffleFrom(payload);
  },
  SET_SALE_BASKET_HASH(state: State, hash: string) {
    state.saleBasketHash = hash || '';
  },
  RESET_SALE_STATE(state: State) {
    state.sales = null;
    state.saleRows = {};
    state.salePromo = null;
    state.saleRaffle = null;
    state.saleBasketHash = '';
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
